import axios from 'axios'
import apiKioskClient from '../clients/ApiKioskClient'

// Kiosk QR attendance: transaction is chosen explicitly by whichever button the
// kiosk operator pressed (1 = Clock In, 2 = Clock Out) — never inferred from
// prior state, per the backend's deliberate move away from auto-detection
// (kiosk_ticket.md KIOSK-018, to avoid a double QR-misread silently closing a
// session it had just opened).
export const submitKioskAttendance = async ({ transaction, qrcode }) => {
    try {
        const response = await apiKioskClient.post('/kiosk/attendance/qr', { transaction, qrcode })
        return response.data
    } catch (error) {
        let errorMessage = 'Unexpected error occurred'

        if (axios.isAxiosError(error)) {
            if (error.response) {
                errorMessage = error.response.data?.message || 'Unexpected error occurred.'
            } else if (error.message.includes('ERR_CONNECTION_REFUSED')) {
                errorMessage = 'Connection refused. Please check the backend server.'
            }
            console.error('Axios error:', error.response?.status, error.response?.data)
        } else {
            console.error('Unexpected error:', error)
            errorMessage = 'An unexpected error occurred: ' + error.message
        }

        return { error: errorMessage } // Return error message in an object
    }
}
